import axios from "axios";
import {BuOption} from "../types/Customer";
import CisContact from "../classes/api/CisContact";

/**
 * Fetches all bus options by making an asynchronous GET request to the specified API endpoint.
 *
 * @async
 * @function fetchAllBus
 * @returns {Promise<BuOption[]>} A promise that resolves to an array of bus option objects.
 */
export const fetchAllBus = async (): Promise<BuOption[]> => {
    const { data } = await axios.get('/api/users/customers');

    return data;
};

/**
 * Asynchronously fetches business unit contacts from the API.
 *
 * Retrieves a list of customer contacts in the CIS format by making a GET request
 * to the specified endpoint. The fetched data is mapped to instances of the CisContact
 * class before being returned.
 *
 * @returns {Promise<CisContact[]>} A promise that resolves to an array of CisContact objects.
 */
export const fetchBuContacts = async (): Promise<CisContact[]> => {
    const { data } = await axios.get('/api/customers/contacts-cis');

    return data.map((item: any) => CisContact.fromJson(item));
};